import React, { Component } from 'react';
import { Spin } from '../Common/Utilities/Spin';
import Login from './Login'
import { Box } from '@mui/material'
import Typography from '@mui/material/Typography';
import { getSiteData } from '../DataServices/SiteDataService'

export class Landing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scrolledDown: false,
            showContactForm: false,
            showLogin: false,
            showDocumentViewer: false,
            height: 0,
            width: 0,
            anchorEl: null,
        }
    }
    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        this.getSiteData();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
    getSiteData = async () => {
        if (this.props.siteID) {
            const site = await getSiteData(this.props.siteID);
            if (site) {
                this.setState({ site });
                document.title = site.pageTitle;
            }
            else {
                this.setState({ loadError: true });
            }
        }
        this.setState({ loadError: true });
    }

    siteNotFound = () => {
        return (
            <Box sx={{ height: "100vh", width: "100%", display: 'flex', justifyContent: "center" }}>
                <Typography variant="h3" sx={{ fontFamily: this.state.site.fontFamily, textAlign: "center", pt: 20, color: "#eee" }}>
                    Site Not Found
                </Typography>
            </Box>
        )
    }
    login = () => {

            return (
                <Box sx={{ paddingTop: { xs: "56px", sm: "64px" }, minHeight: "100vh", height: "100%", }} className={this.props.dark && "dark"} >
                    <Login
                        appIdentifier={this.props.siteID}
                        setUserInfo={this.props.setUserInfo}
                        setToken={this.props.setToken}
                        logo={this.state.site.clientPortal.loginLogo}
                        buttonColor={this.state.site.clientPortal.buttonColor}
                        accountRequestMessage={this.state.site.clientPortal.accountRequestMessage}
                    />
                </Box>
            )
    }


    loadingSpinner = () => {
        return (
            <Box sx={{ height: "100vh", width: "100%", display: 'flex', justifyContent: "center" }}>
                <Spin open={!this.state.site && !this.state.loadError} message="Loading..." />
            </Box>
        )
    }
    spacer = (y) => {
        return (<Box sx={{ height: { xs: 0, sm: y } }} />)
    }
    staticSpacer = (y) => {
        return (<Box sx={{ height: { xs: y } }} />)
    }

    render() {
        if (this.state.site) {
            return this.login();
        } else {
            if (this.state.loadError) 
                return this.siteNotFound();           
        }
        return this.loadingSpinner();
    }
}

